// import { StandardTextFieldProps } from '@material-ui/core'
import { TextFieldProps } from '@mui/material'
import { KeyboardEvent } from 'react'
import { Controller } from 'react-hook-form'

// interface TextInputHOCProps extends Omit<StandardTextFieldProps, 'variant'> {
//   name: string
//   control: any
//   variant?: 'standard' | 'filled' | 'outlined'
//   pattern?: string
//   justNumbers?: boolean
//   onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void
// }

type TTextInputHOCProps = TextFieldProps & {
  name: string
  control: any
  pattern?: string
  justNumbers?: boolean
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void
}

const withTextInputController = (
  WrappedComponent: (
    props: TextFieldProps
  ) => JSX.Element
) => {
  const WithTextInputController = (props: TTextInputHOCProps) => {
    const { name, control, onKeyDown } = props
    return (
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState }) => {
          //TODO: to be added some global validations here
          const fieldValue = field.value
          return (
            <WrappedComponent
              {...props}
              value={fieldValue}
              onChange={field.onChange}
              onBlur={field.onBlur}
              onKeyDown={onKeyDown}
            />
          )
        }}
      />
    )
  }
  return WithTextInputController
}

export default withTextInputController
